// src/components/AuthDetails.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FaUserCircle, FaSignOutAlt, FaWifi } from 'react-icons/fa';
import './AuthDetails.css';

const AuthDetails = () => {
    const { currentUser, logout, isOfflineAuth, userData } = useAuth();

    const userSignOut = async () => {
        try {
            await logout();
            console.log('Cierre de sesión exitoso');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="auth-details-card">
            {currentUser ? (
                <>
                    <div className="user-info">
                        <FaUserCircle className="user-icon" />
                        <div>
                            <p className="signed-in-as">
                                Sesión iniciada como:
                                {isOfflineAuth && (
                                    <span style={{ fontSize: '0.75rem', marginLeft: '6px', color: '#f59e0b', fontWeight: 'bold' }}>
                                        <FaWifi style={{ marginRight: '3px' }}/>(Offline)
                                    </span>
                                )}
                            </p>
                            <p className="user-email">
                                {userData?.displayName ? (
                                    <>
                                        <span className="user-name-portal">{userData.displayName}</span>{' '}
                                        <span>• </span>
                                    </>
                                ) : null}
                                {currentUser.email}
                            </p>
                        </div>
                    </div>
                    <button onClick={userSignOut} className="sign-out-button">
                        <FaSignOutAlt /> Cerrar Sesión
                    </button>
                </>
            ) : (
                <p>No hay sesión iniciada</p>
            )}
        </div>
    );
};

export default AuthDetails;